import { ApiErrorInterface } from "../../../interfaces/ApiErrorResponseInterface";
import styles from "./styles.scss";

interface ApiErrorsProps {
  apiErrors: ApiErrorInterface[];
  className?: string;
}

export const ApiErrors = ({ apiErrors, className }: ApiErrorsProps) => {
  if (apiErrors.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.errors} ${className || ""}`}>
      {apiErrors.map((error: ApiErrorInterface, i: number) => {
        return (
          <p key={`MessageForm-apiErrors-${i}`} className={styles.error}>
            {error.message}
          </p>
        );
      })}
    </div>
  );
};
